export default "__VITE_ASSET__CASPc_Wb__"